module.exports = __webpack_public_path__ + "static/media/game_cover_dicero@768.e779c954.png";